import React from 'react';
import { TextField } from '@mui/material';

function TextFieldComp ({id_, fieldLabel, defaultValue_}) {

  return (
    <TextField
        id={"outlined-multiline-flexible"}
        multiline
        maxRows={2}
        label={fieldLabel}
        style = {{width: 400}}
        InputProps={{
          readOnly: true,
        }}
        defaultValue={defaultValue_}
    />
  )

}

export default TextFieldComp;